<template>
  <div class="AppDatePicker">
    <label v-if="label" class="title title-date">
      {{ label }}
    </label>
    <div>
      <date-picker
        :formatter="masks"
        v-model="date"
        type="date"
        :placeholder="$t('subscription_details.datePicker.placeholder', 'Select date')"
        :lang="languageCode"
        :disabled-date="notBeforeToday"
        :default-value="new Date()"
        @input="enteredSpecficDate"
      />
    </div>
  </div>
</template>

<script>
  import { detectedCulture, dataLocalFormat } from '@/utilities/common/culture'
  import DatePicker from 'vue2-datepicker'

  export default {
    name: 'app-date-picker',

    inheritAttrs: false,

    props: {
      label: {
        type: String,
        default: null
      }
    },

    data () {
      return {
        languageCode: detectedCulture.languageCode,
        date: '',
        masks: {
          weekdays: 'WW',
          input: [dataLocalFormat]
        }
      }
    },

    components: {
      DatePicker
    },

    methods: {
      enteredSpecficDate () {
        this.$emit('getDate', this.date)
      },

      notBeforeToday (date) {
        return date < new Date(new Date().setHours(0, 0, 0, 0))
      }
    }
  }
</script>

<style lang="scss">
  .AppDatePicker {
    display: block;
    position: relative;
    margin-bottom: .4rem;
  }
</style>
